import { progressiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const MusicWeek: Site = {
  id: 'musicweek',
  logo: 'svg/musicweek.svg',
  label: 'Music Week',
  analyticsName: 'musicweek',
  hostname: 'musicweek.com',
  platform: 'progressive',
  selector: progressiveVanillaSelector,
};
